<div [class]="classes">
    <!-- Sub-decoración estética opcional -->
    <div *ngIf="!glass" class="absolute -top-10 -right-10 w-32 h-32 bg-primary-100/30 rounded-full blur-3xl"></div>
    <div *ngIf="!glass" class="absolute -bottom-10 -left-10 w-32 h-32 bg-blue-100/30 rounded-full blur-3xl"></div>

    <div class="relative z-10">
        <!-- Metric & Stat layout fallback -->
        <div *ngIf="title || value" [ngClass]="iconPosition === 'start' && icon ? 'flex flex-row items-center gap-4 w-full mb-3' : 'flex flex-col w-full mb-3'">
            <div *ngIf="icon" class="flex-shrink-0">
                <span class="iconify" [ngClass]="[iconClass || 'text-3xl text-primary-600']" [attr.data-icon]="icon"></span>
            </div>
            <div class="flex flex-col gap-0.5 flex-1 min-w-0">
                <p *ngIf="value" class="font-black text-2xl text-gray-900 tracking-tight">{{ value }}</p>
                <p *ngIf="title" class="font-bold text-sm text-gray-700">{{ title }}</p>
                <p *ngIf="subtitle" class="font-medium text-xs text-slate-500 mt-0.5 line-clamp-2">{{ subtitle }}</p>
            </div>
        </div>

        <ng-content></ng-content>
    </div>
</div>